export default "__VITE_ASSET__ebbfb3bc__"